import * as React from 'react';

import EmptyStateFolder140 from './EmptyStateFolder140';

export const emptyStateFolder140 = () => <EmptyStateFolder140 />;

export default {
    title: 'Illustration|EmptyStateFolder140',
    component: EmptyStateFolder140,
    parameters: {
        notes: "`import EmptyStateFolder140 from 'box-ui-elements/es/illustration/EmptyStateFolder140';`",
    },
};
